import * as microsoftTeams from "@microsoft/teams-js";
import { useEffect, useState } from "react";
import axios from "axios";
import showConsentDialog from "../../../utils/show-consent-dialog";

export default function Login() {
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState<any>();
  const [needsConsent, setNeedsConsent] = useState(false);

  const ssoLoginSuccess = async (result: string) => {
    exchangeClientTokenForServerToken(result);
  };

  const ssoLoginFailure = (error: any) => {
    console.error("Login failed: ", error);
    const errorMsg = typeof error === 'string' ? error : (error?.message || JSON.stringify(error) || "");

    // Lỗi trả về từ Teams SDK (VD: invalid_grant, consent_required)
    if (
      errorMsg === "consent_required" || 
      errorMsg.includes("invalid_grant") || 
      errorMsg.includes("AADSTS65001")
    ) {
      setNeedsConsent(true);
    }
  };

  useEffect(() => {
    console.log("initLoginToken called");
    microsoftTeams.app.initialize().then(() => {
      microsoftTeams.app
        .getContext()
        .then((context: microsoftTeams.app.Context) => {
          setCurrentUser(context?.user as any);

          microsoftTeams.authentication
            .getAuthToken()
            .then((result: string) => {
              ssoLoginSuccess(result);
              setLoading(false);

              if (context?.page?.id !== "ict24h.m365.tabs.portal") {
                if (microsoftTeams.pages && microsoftTeams.pages.currentApp) {
                  microsoftTeams.pages.currentApp.navigateTo({
                    pageId: "ict24h.m365.tabs.portal",
                  });
                } else {
                  microsoftTeams.pages.tabs.navigateToTab({
                    entityId: "ict24h.m365.tabs.portal",
                    tabName: "Portal",
                  });
                }
              }
            })
            .catch((error: string) => {
              ssoLoginFailure(error);
              setLoading(false);
            });
        });
    });
  }, []);

  async function exchangeClientTokenForServerToken(clientToken: string) {
    try {
      const { data } = await axios.post(
        "https://cenprecast-pms.cwr.i24h.app/auth/login-ms-obh",
        {
          token: clientToken,
          clientId: process.env.REACT_APP_MSAL_APP_ID,
        },
      );

      // Xử lý lỗi từ server báo về cần cấp quyền
      if (
        data?.error &&
        data?.error[0]?.response?.errrorCode === "consent_required"
      ) {
        setNeedsConsent(true);
        return;
      }

      console.log("callGetTokens: ", data);
    } catch (err) {
      console.error("exchangeClientTokenForServerToken failed:", err);
    }
  }

  const handleConsentClick = () => {
    showConsentDialog(
      (res) => {
        console.log("Xác thực thành công", res);
        window.location.reload();
      },
      (err) => {
        console.error("Xác thực thất bại", err);
      }
    );
  };

  return (
    <div style={{ padding: 20 }}>
      {needsConsent ? (
        <div>
          <p>Ứng dụng cần được cấp quyền quản trị để hoạt động.</p>
          <button onClick={handleConsentClick}>
            Cấp quyền hệ thống (Admin Consent)
          </button>
        </div>
      ) : (
        <>
          {currentUser?.userPrincipalName && (
            <p>Tài khoản: {currentUser.userPrincipalName}</p>
          )}

          {loading ? (
            <p>Đang kiểm tra tài khoản ...</p>
          ) : (
            <p>Đã kiểm tra xong!</p>
          )}
        </>
      )}
    </div>
  );
}
